import React from "react";

interface SectionHeaderProps {
  header: React.ReactNode;
  rightSideContent?: React.ReactNode;
}

export default function SectionHeader({
  header,
  rightSideContent,
}: SectionHeaderProps) {
  return (
    <div className="flex-row flex-center space-between border-bottom padding-bottom-xs margin-bottom-md">
      <span className="font-weight-bold">{header}</span>
      {rightSideContent}
    </div>
  );
}
